import * as React from 'react';
import b_ from 'b_';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import List from './components/List';

import './index.scss';

const b = b_.with('main-page-partners');

interface Props {}

type Enhanced = Props & InjectedTranslateProps;

const Partners: React.FC<Enhanced> = ({ t }) => {
  return (
    <div className={b()} data-testid={'main-page-partners'}>
      <div className={b('title')}>{t('We have been investing in the US market for 11 years')}</div>
      <div className={b('text')}>
        {t(
          'Our team is made up of highly skilled professional traders that got together in 2009 to found United Traders'
        )}
      </div>
      <List />
    </div>
  );
};

export default translate(Partners);
